import type { TaskResult } from "../types";

export async function gradeProject7(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Formato condicional para duplicados en A2:A57 de "Inventario de alimentos"
  // Verificar que existe una regla de formato condicional para valores duplicados con fuente roja
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Inventario de alimentos");
    const rango = ws.getRange("A2:A57");
    const formatosCondicionales = rango.conditionalFormats;
    formatosCondicionales.load("items");
    await context.sync();

    let passed = false;
    for (const formato of formatosCondicionales.items) {
      // Verificar preset "DuplicateValues" (menú Resaltar reglas > Valores duplicados)
      if (formato.type === Excel.ConditionalFormatType.presetCriteria) {
        formato.preset.load("rule");
        await context.sync();

        const criterion = String(formato.preset.rule.criterion);
        if (criterion === "DuplicateValues") {
          formato.preset.format.font.load("color");
          await context.sync();

          const fontColor = (formato.preset.format.font.color || "").toUpperCase();
          if (fontColor.includes("FF0000") || fontColor.includes("FF") && fontColor.length <= 9) {
            passed = true;
          }
          break;
        }
      }

      // Verificar regla personalizada basada en COUNTIF (alternativa)
      if (formato.type === Excel.ConditionalFormatType.custom) {
        formato.custom.load("rule");
        await context.sync();

        const formula = (formato.custom.rule.formula || "").toUpperCase();
        if (formula.includes("COUNTIF") || formula.includes("CONTAR.SI")) {
          formato.custom.format.font.load("color");
          await context.sync();

          const fontColor = (formato.custom.format.font.color || "").toUpperCase();
          if (fontColor.includes("FF0000") || fontColor === "#FF0000") {
            passed = true;
          }
        }
      }
    }
    results.push({ taskId: 1, passed });
  });

  // Tarea 2: COUNTIFS en H12 de "Ventas actuales T1"
  // Debe contar camiones con Hamburguesa y Marzo > $2,500 (resultado = 2)
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Ventas actuales T1");
    const celda = ws.getRange("H12");
    celda.load("formulas,values");
    await context.sync();

    const formula = (celda.formulas[0][0] || "").toString().toUpperCase();
    const tieneFormula =
      formula.includes("COUNTIFS") || formula.includes("CONTAR.SI.CONJUNTO");

    const valor = Number(celda.values[0][0]);
    const valorCorrecto = Math.abs(valor - 2) < 0.01;

    results.push({ taskId: 2, passed: tieneFormula && valorCorrecto });
  });

  // Tarea 3: Gráfico de proyección solar (Sunburst) en "Objetivo de ventas T1"
  // Debe usar solo columnas Ubicación y Total
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Objetivo de ventas T1");
    const charts = ws.charts;
    charts.load("items");
    await context.sync();

    let passed = false;
    for (const chart of charts.items) {
      chart.load("chartType");
      await context.sync();

      if (chart.chartType === Excel.ChartType.sunburst) {
        // Verificar que el gráfico usa columnas Ubicación (A) y Total (E)
        // El sourceData del chart indica el rango de datos
        chart.series.load("count");
        await context.sync();

        // Con Ubicación + Total → 1 serie ("Total")
        // Con todas las columnas → 4 series (Enero, Febrero, Marzo, Total)
        // Con Ubicación + Marzo → 1 serie ("Marzo") — debemos rechazar
        if (chart.series.count === 1) {
          const series0 = chart.series.getItemAt(0);
          series0.load("name");
          await context.sync();

          const nombre = (series0.name || "").toLowerCase();
          // Solo pasa si la serie se llama "Total" (no "Marzo", "Enero", etc.)
          passed = nombre.includes("total");
        }
        break;
      }
    }
    results.push({ taskId: 3, passed });
  });

  // Tarea 4: Función AHORA()/NOW() en H13 de "Ventas actuales T1"
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Ventas actuales T1");
    const celda = ws.getRange("H13");
    celda.load("formulas");
    await context.sync();

    const formula = (celda.formulas[0][0] || "").toString().toUpperCase();
    const passed = formula.includes("NOW") || formula.includes("AHORA");
    results.push({ taskId: 4, passed });
  });

  // Tarea 5: Totales generales solo en columnas en "Tabla dinámica"
  // showColumnGrandTotals = true, showRowGrandTotals = false
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Tabla dinámica");
    const pivotTables = ws.pivotTables;
    pivotTables.load("items");
    await context.sync();

    let passed = false;
    for (const pt of pivotTables.items) {
      pt.layout.load("showColumnGrandTotals,showRowGrandTotals");
      await context.sync();

      if (
        pt.layout.showColumnGrandTotals === true &&
        pt.layout.showRowGrandTotals === false
      ) {
        passed = true;
        break;
      }
    }
    results.push({ taskId: 5, passed });
  });

  return results;
}
